import React from 'react';
import styles from './PasswordStrengthBar.module.css';

/**
 * PasswordStrengthBar Component - TECNILAND
 * Barra visual de fortaleza de contraseña
 * Muestra progreso y requisitos de seguridad
 */
function PasswordStrengthBar({ strength, checks }) {
  // Etiquetas de fortaleza
  const strengthLabels = [
    { label: 'Muy débil', color: '#ff4444' },
    { label: 'Débil', color: '#ff8844' },
    { label: 'Aceptable', color: '#ffaa00' },
    { label: 'Buena', color: '#88cc00' },
    { label: 'Fuerte', color: '#00ff00' }
  ];

  const currentStrength = strengthLabels[strength] || strengthLabels[0];

  return (
    <div className={styles.container}>
      {/* Barra de progreso */}
      <div className={styles.barContainer}>
        <div 
          className={styles.barFill}
          style={{ 
            width: `${(strength / 4) * 100}%`,
            backgroundColor: currentStrength.color
          }}
        ></div>
      </div>

      {/* Etiqueta de fortaleza */}
      <div className={styles.info}>
        <span 
          className={styles.label}
          style={{ color: currentStrength.color }}
        >
          {currentStrength.label}
        </span>
        
        {/* Requisitos */}
        <div className={styles.requirements}>
          <span className={checks?.minLength ? styles.met : styles.unmet}>
            8+ caracteres
          </span>
          <span className={checks?.hasUppercase ? styles.met : styles.unmet}>
            Mayúscula
          </span>
          <span className={checks?.hasNumber ? styles.met : styles.unmet}>
            Número
          </span>
          <span className={checks?.hasSpecial ? styles.met : styles.unmet}>
            Especial
          </span>
        </div>
      </div>
    </div>
  );
}

export default PasswordStrengthBar;
